import React, {useState, useEffect} from "react";
import Slider from "react-slick";

const SimilarEvents = ({similarEvents}) => {
  const [imagess, setImagess] = useState([]);
  const [sData, setSData] = useState([]);
  useEffect(() => {
    let nData = similarEvents;
    let mData = nData?.length > 3 ? nData.slice(0, 3) : nData;
    setSData(mData);
  }, [similarEvents]);
  var settings = {
    infinite: false,
    centerMode: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    showFull: false,
    showLoader: false,
    dots: true,
    arrows: false,
    focusOnSelect: true,
  };

  return (
    <>
      <div id="sumu-wrapper">
        <div id="simil">Similar Realevents</div>
        <div id="smi-row">
          {sData !== undefined &&
            sData.length > 0 &&
            sData?.map((s, i) => {
              return (
                <div id="simi-wr">
                  <div id="simi-card">
                    <Slider {...settings}>
                      {s?.coverImage && s?.coverImage.length > 3
                        ? s?.coverImage.slice(0, 4).map((i, index) => {
                            return (
                              <>
                                <span id="topper"></span>
                                <img
                                  src={`https://media.bookeventz.com/html/bookeventz.com/images/albums/${i.fileName}`}
                                  alt="Event Card Image"
                                  id="shiti-icon"
                                />
                                {/* <img
                                  src="../../media/heart.svg"
                                  alt="Heart Icon"
                                  id="hearty-icon"
                                /> */}
                                {/* {index == 0 && (
                                  <a
                                    href={`https://api.whatsapp.com/send?text=https://www.bookeventz.com/real-events/${s.uniqueLink}`}
                                    data-action="share/whatsapp/share"
                                    target="_blank"
                                  >
                                    <img
                                      src="../../media/sh.svg"
                                      alt="Share Icon"
                                      id="share-icon"
                                    />
                                  </a>
                                )} */}
                              </>
                            );
                          })
                        : null}
                    </Slider>
                  </div>
                  <div id="simi-bttom">
                    <a
                      href={`https://www.bookeventz.com/real-events/${s.uniqueLink}`}
                      target="_blank"
                    >
                      <span id="simi-name">{s.name}</span>
                    </a>
                    <span id="simi-wed">{s.theme}</span>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default SimilarEvents;
